import { ArticlesLieuxDepartApi } from '@/api/articles-lieux-depart';
import { ArticleLieuDepart } from '@/model/article-lieu-depart';
import { uniqBy } from 'lodash';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('articlesLieuxDepart');
builder.addStatePart('liste', null, () => ArticlesLieuxDepartApi.getArticlesLieuxDepart(), 'NONE', 1800 /* 30m */);

builder.setGetters({
  articles: (state: any) => !state.liste ? [] : uniqBy((state.liste as ArticleLieuDepart[]).map(ald => ald.article), 'id'),
  getArticle: (state: any) => (idArticle: number) => !state.liste ? null : (state.liste as ArticleLieuDepart[]).map(ald => ald.article).filter(a => a.id === idArticle)[0],
  getLieuxDepart: (state: any) => (idArticle: number) => !state.liste ? null : uniqBy((state.liste as ArticleLieuDepart[]).filter(ald => ald.article.id === idArticle).map(ald => ald.lieuDepart), 'id'),
  getArticlesLieuxDepart: (state: any) => (idArticle: number) => !state.liste ? null : uniqBy((state.liste as ArticleLieuDepart[]).filter(ald => ald.article.id === idArticle), 'id')
});

export default builder.build();
